module.exports = __webpack_public_path__ + "static/media/CrossCut Logo-11.8fe0a3d4.jpg";